import React from 'react';
import Chart from './components/chart';
import "typeface-roboto-condensed";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Analytics from './analytics';

class App extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            analytics: new Analytics()
        }
    }

    render() {
        return (
            <React.Fragment>
                <Chart analytics={this.state.analytics} />
            </React.Fragment>
        )
    }
}

export default App;
